/** @format */

import { msisdnConstants } from './actions';
import { reducerDebug } from '../../core/debug';

export function msisdnReducers(state = {}, action) {
    reducerDebug('Msisdn reducer: ' + action.type);
    switch (action.type) {
        case msisdnConstants.LIST_POOL:
        case msisdnConstants.LIST_POOL_NUMBERS:
        case msisdnConstants.LIST_POOL_NAME_SELECT:
        case msisdnConstants.LIST_POOL_NUMBERS_CHOOSE:
            return {
                type: action.type,
                collections: action.collections,
            };
        case msisdnConstants.LIST_POOL_ITEM_LIST:
        case msisdnConstants.LIST_POOL_ITEM:
        case msisdnConstants.LIST_POOL_EDIT:
            return {
                type: action.type,
                item: action.item,
            };
        case msisdnConstants.LIST_POOL_ADD_NEW:
        case msisdnConstants.LIST_POOL_EDIT_SAVE:
            return {
                type: action.type,
                success: true,
            };
        case msisdnConstants.LIST_POOL_DELETE:
            return {
                type: action.type,
                success: false,
                rows: null,
            };
        case msisdnConstants.ACTIVATE_MSISDN_WITHOUT_BLOCK:
        default:
            return {
                ...state,
                type: action.type,
            };
    }
}
